import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend('required', required);

export const rules = {
    username: {
        required: true
    },
    password: {
        required: true
    },
    recover: {
        required: true
    }
};